module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-white-2",
    attrs: {
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 xs-text-center"
  }, [_c('p', {
    staticClass: "vw-bold font-family-alt text-extra-large"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "margin-5-5 no-margin-bottom no-margin-rl text-large text-gray-dark-2"
  }, [_vm._t("text")], 2), _vm._v(" "), _c('a', {
    staticClass: "page-scroll btn btn-outline-black btn-medium margin-6-5 no-margin-bottom no-margin-rl",
    on: {
      "click": function($event) {
        _vm.goToMenuItem('register')
      }
    }
  }, [_vm._v("\n                    Tilmeld dig nu\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-md-offset-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 xs-margin-10 sm-margin-5 xs-no-margin-bottom sm-no-margin-bottom xs-no-margin-rl sm-no-margin-rl xs-text-center"
  }, [_c('i', {
    staticClass: "fa fa-map-marker display-block text-base-color title-extra-large-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 margin-5 no-margin-bottom no-margin-rl text-large text-uppercase vw-bold"
  }, [_vm._v("Adresse")]), _vm._v(" "), _c('p', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-large text-gray-dark-2"
  }, [_vm._t("address")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 xs-margin-10 sm-margin-5 xs-no-margin-bottom sm-no-margin-bottom xs-no-margin-rl sm-no-margin-rl xs-text-center"
  }, [_c('i', {
    staticClass: "fa fa-clock-o display-block text-base-color title-extra-large-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 margin-5 no-margin-bottom no-margin-rl text-large text-uppercase vw-bold"
  }, [_vm._v("Dato & tid")]), _vm._v(" "), _c('p', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-large text-gray-dark-2"
  }, [_vm._t("datetime")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 sm-margin-5 sm-no-margin-bottom sm-no-margin-rl xs-text-center"
  }, [_c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-handshake-o display-block text-base-color title-extra-large-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "display-block font-family-alt font-weight-700 letter-spacing-1 margin-5 no-margin-bottom no-margin-rl text-large text-uppercase vw-bold"
  }, [_vm._v("Partnere")]), _vm._v(" "), _c('p', {
    staticClass: "margin-3 no-margin-bottom no-margin-rl text-large text-gray-dark-2 partners"
  }, [_vm._t("partners")], 2)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row no-padding-rl no-padding-top padding-8"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 text-center"
  }, [_c('h3', {
    staticClass: "font-family-alt font-weight-700 letter-spacing-2 text-uppercase xs-title-small title-medium title-sideline-base-color"
  }, [_vm._v("Praktiske informationer")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97ee29d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home-sections/practical-info.vue
// module id = 246
// module chunks = 1